import api from './api';

/**
 * Users Service
 * Handles all user management API calls
 */
const usersService = {
    /**
     * Get all users with pagination and filters
     * @param {Object} params - Query parameters
     * @returns {Promise<Object>}
     */
    getAll: async (params = {}) => {
        const queryString = new URLSearchParams(params).toString();
        return api.get(`/admin/users${queryString ? `?${queryString}` : ''}`);
    },

    /**
     * Get user by ID
     * @param {string} id - User ID
     * @returns {Promise<Object>}
     */
    getById: async (id) => {
        return api.get(`/admin/users/${id}`);
    },

    /**
     * Change user status (activate/suspend/pending)
     * @param {string} id - User ID
     * @param {string} status - New status
     * @returns {Promise<Object>}
     */
    changeStatus: async (id, status) => {
        return api.patch(`/admin/users/${id}/status`, { status });
    },

    /**
     * Delete user
     * @param {string} id - User ID
     * @returns {Promise<Object>}
     */
    delete: async (id) => {
        return api.delete(`/admin/users/${id}`);
    },

    /**
     * Export users data
     * @param {Object} params - Query parameters
     * @returns {Promise<Object>}
     */
    export: async (params = {}) => {
        const queryString = new URLSearchParams(params).toString();
        return api.get(`/admin/users/export${queryString ? `?${queryString}` : ''}`);
    }
};

export default usersService;
